export default __webpack_public_path__ + "0112ac241857a7de9cd946eb59f8975d.svg";